import React from 'react'
import styled from 'styled-components'
import { SCREEN_SIZE } from '../../../lib/Media'

const StyledPanel = styled.div`
  border-radius: 0.25rem;
  margin-bottom: 1.25rem;

  ${({ shadow }) =>
    shadow &&
    `
    border: none;
    box-shadow: 0.0625rem 0.1875rem 0.6875rem 0 rgba(61, 61, 61, 0.22);
  `}
`

const Header = styled.div`
  background: #1454b8;
  padding: 0.5rem 1rem;
  color: #fff;
  border-radius: 0.25rem 0.25rem 0 0;
  font-weight: 600;
  line-height: 1.5;
  font-size: 0.875rem;
  ${SCREEN_SIZE.From.Desktop} {
    font-size: 1.125rem;
  }
`

const Content = styled.div`
  background: #fff;
  padding: 1rem;
  border-radius: 0.25rem;

  ${Header} + & {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  ${({ border }) => border && `border: 0.0625rem solid #ccc;`}
`

const Panel = ({ title, children, shadow, border, ...props }) => {
  return (
    <StyledPanel shadow={shadow} {...props}>
      {title && <Header>{title}</Header>}
      <Content border={border}>{children}</Content>
    </StyledPanel>
  )
}

export default Panel
